/** "Tue, Nov 3, 2026, 14:00 UTC": job times read in UTC everywhere a person sees them. */
export function formatUtc(at: Date | string): string {
  const date = typeof at === "string" ? new Date(at) : at;
  const day = date.toLocaleDateString("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
    year: "numeric",
    timeZone: "UTC",
  });
  return `${day}, ${date.toISOString().slice(11, 16)} UTC`;
}

/** A run's counts as words: "candidates 2, flagged 1"; "Nothing counted" for none. */
export function formatCounts(counts: Record<string, number> | null): string {
  const entries = Object.entries(counts ?? {});
  if (entries.length === 0) return "Nothing counted";
  return entries
    .map(([key, value]) => `${key.replace(/([a-z])([A-Z])/g, "$1 $2").toLowerCase()} ${value}`)
    .join(", ");
}

/** What a run ended with: its error when it has one, else its counts; nothing while running. */
export function runResult(run: {
  status: string;
  counts: Record<string, number> | null;
  error: string | null;
}): string {
  if (run.error) return run.error;
  if (run.status === "running") return "";
  return formatCounts(run.counts);
}
